<h1 mat-dialog-title>Trip4YouMaps logout</h1>
<div mat-dialog-content>
</div>

<div mat-dialog-actions>
    <div style="display: flex; flex-direction: row-reverse; width:100%;">
        <button mat-button (click)="onCancel()">Cancel</button>
        <button mat-button cdkFocusInitial (click)="onLogout()">Logout</button>
    </div>
</div>